///v1/carts/me
import Store from 'redux/store';
import {
  ADD_ITEM_TO_CART,
  ADD_ITEM_TO_CART_FAIL,
  ADD_ITEM_TO_CART_SUCCESS,
  FETCH_CART,
  FETCH_CART_FAIL,
  FETCH_CART_SUCCESS,
  UPDATE_ITEM_CART,
  UPDATE_ITEM_CART_FAIL,
  UPDATE_ITEM_CART_SUCCESS,
  DELETE_ITEM_CART,
  DELETE_ITEM_CART_FAIL,
  DELETE_ITEM_CART_SUCCESS,
  ADD_COUPON_TO_CART,
  ADD_COUPON_TO_CART_SUCCESS,
  ADD_COUPON_TO_CART_FAIL,
  REMOVE_COUPON_TO_CART,
  REMOVE_COUPON_TO_CART_SUCCESS,
  REMOVE_COUPON_TO_CART_FAIL,
} from 'redux/Reducers/Cart/CartReducer';

import { cloudloyalty } from '../clients';

/* eslint-disable */

const FetchCart = async (User, finallyCallback = () => {}) => {
  Store.dispatch({ type: FETCH_CART });
  cloudloyalty(User)
    .get(`/v1/carts/me`)
    .then((response) => {
      Store.dispatch({
        type: FETCH_CART_SUCCESS,
        payload: {
          ...response,
        },
      });
    })
    .catch((e) => {
      Store.dispatch({
        type: FETCH_CART_FAIL,
        error: e,
      });
    })
    .finally(() => {
      finallyCallback();
    });
};
export default FetchCart;

export const AddToCart = async (
  User,
  finallyCallback = () => {},
  payload = {}
) => {
  Store.dispatch({ type: ADD_ITEM_TO_CART });

  const { redirectToCart } = payload;
  delete payload.redirectToCart;

  cloudloyalty(User)
    .post(`/v1/carts/me/items`, payload)
    .then((response) => {
      Store.dispatch({
        type: ADD_ITEM_TO_CART_SUCCESS,
        payload: {
          ...response,
          redirectToCart,
        },
      });
    })
    .catch((e) => {
      Store.dispatch({
        type: ADD_ITEM_TO_CART_FAIL,
        error: e,
      });
    })
    .finally(() => {
      finallyCallback();
    });
};

export const UpdateToCart = async (
  User,
  finallyCallback = () => {},
  payload = {}
) => {
  Store.dispatch({ type: UPDATE_ITEM_CART });

  const cleanPayload = {
    quantity: payload.quantity,
    vendorId: payload.vendorId,
  };
  cloudloyalty(User)
    .put(`/v1/carts/me/items/${payload?.sku}`, cleanPayload)
    .then((response) => {
      Store.dispatch({
        type: UPDATE_ITEM_CART_SUCCESS,
        payload: {
          ...response,
        },
      });
    })
    .catch((e) => {
      Store.dispatch({
        type: UPDATE_ITEM_CART_FAIL,
        error: e,
      });
    })
    .finally(() => {
      finallyCallback();
    });
};

export const DeleteToCart = async (
  User,
  finallyCallback = () => {},
  payload = {}
) => {
  Store.dispatch({ type: DELETE_ITEM_CART });

  cloudloyalty(User)
    .delete(`/v1/carts/me/items/${payload?.sku}`)
    .then((response) => {
      Store.dispatch({
        type: DELETE_ITEM_CART_SUCCESS,
        payload: {
          ...response,
        },
      });
    })
    .catch((e) => {
      Store.dispatch({
        type: DELETE_ITEM_CART_FAIL,
        error: e,
      });
    })
    .finally(() => {
      finallyCallback();
    });
};

export const AddCouponToCart = async (
  User,
  finallyCallback = () => {},
  payload = {}
) => {
  Store.dispatch({ type: ADD_COUPON_TO_CART });

  cloudloyalty(User)
    .patch(`/v1/carts/me/coupon`, payload,{
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      Store.dispatch({
        type: ADD_COUPON_TO_CART_SUCCESS,
        payload: {
          ...response,
        },
      });
    })
    .catch((e) => {
      Store.dispatch({
        type: ADD_COUPON_TO_CART_FAIL,
        error: e,
      });
    })
    .finally(() => {
      finallyCallback();
    });
};

export const RemoveCouponCart = async (
  User,
  finallyCallback = () => {},
  payload = {}
) => {
  Store.dispatch({ type: REMOVE_COUPON_TO_CART });

  cloudloyalty(User)
    .delete(`/v1/carts/me/coupon`, {
      headers: {
        'Content-Type': 'application/json',
      },
      data: payload,
    })
    .then((response) => {
      Store.dispatch({
        type: REMOVE_COUPON_TO_CART_SUCCESS,
        payload: {
          ...response,
        },
      });
    })
    .catch((e) => {
      Store.dispatch({
        type: REMOVE_COUPON_TO_CART_FAIL,
        error: e,
      });
    })
    .finally(() => {
      finallyCallback();
    });
};

